import { render, staticRenderFns } from "./RejectionReasonsListPage.vue?vue&type=template&id=c83b0dda&scoped=true&"
import script from "./RejectionReasonsListPage.vue?vue&type=script&lang=ts&"
export * from "./RejectionReasonsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./RejectionReasonsListPage.vue?vue&type=style&index=0&id=c83b0dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83b0dda",
  null
  
)

export default component.exports